module.exports = __webpack_public_path__ + "img/4yue.7315329c.png";